import React from "react";
import cogoToast from "cogo-toast";

// import Explanation from "../modals/Explanation";

var answer = [];
class QuizFourPicOneWord extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      answerArr: [],
      error: "",
      optionSelected: "",
      quiz_data: {
        quiz_title: ""
      },

      question_list: {
        question_title: "",
        question_media: [
          {
            media_path: ""
          }
        ],
        question_options: [
          {
            option_name: "",
            option_id: ""
          }
        ]
      },
      ans: [],
      count: 0,
      rightAns: "none",
      wrongAns: "none",
      quiz_answers: [],
      date: 0
    };
  }
  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
  }
  tick() {
    this.setState({ date: this.state.date + 1 });
  }
  componentWillMount() {
    this.setState({
      question_list: this.props.unitDetails,
      start: this.state.date
    });


    setTimeout(() => {
      const str = this.props.unitDetails.question_options[0].option_name.toUpperCase();
      let temp = [];
      temp = str.split("");
      console.log(temp);

      for (let i = temp.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [temp[i], temp[j]] = [temp[j], temp[i]];
      }

      this.setState({ optionsArr: temp });
    }, 100);
  }

  componentDidUpdate() {
    let answer = "";
    this.state.answerArr.map(letter => {
      answer = answer.concat(letter);
    });
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    this.setState({ date: this.state.date + 1 });
  }

  findAns = ans => {
    return this.props.unitDetails.question_options.find(item => {
      return parseInt(item.option_id, 10) === parseInt(ans, 10);
    });
  };
  printOption = () => {
    return this.state.optionsArr.map(option => {
      return (
        <div
          onClick={this.removeFromOption}
          className="split-letter shadow-sm"
          style={{
            padding: `${this.state.optionsArr.length > 6 ? "7px 10px" : ""}`
          }}
        >
          {option}
        </div>
      );
    });
  };

  removeFromOption = e => {
    if (e.target.classList.contains("split-letter")) {
      e.target.classList.add("blank-item");
    }

    e.target.style.pointerEvents = "none";

    const value = e.target.innerHTML;
    this.setState({
      answerArr: [...this.state.answerArr, value]
    });

    answer.push(e.target.innerHTML);

    var answerWord = answer.join("");

    const allSplitBox = document.querySelectorAll(".split-letter ");

    if (allSplitBox.length === answer.length) {
      if (
        answerWord.toLowerCase() ==
        this.props.unitDetails.question_options[0].option_name.toLowerCase()
      ) {
        cogoToast.success("Correct", { position: "top-center" });
        this.setState({ rightAns: "block", wrongAns: "none" });
        for (let i = 0; i < allSplitBox.length; i++) {
          allSplitBox[i].style.pointerEvents = "none";
        }
        answer = [];
        this.props.playCorrectAudio();
        var a = {};
        a.answer = "Correct";
        a.text = this.props.unitDetails.correct_feedback;
        a.video = this.props.unitDetails.correct_feedback_video;
        this.setState({ open: true, explain_data: a });
        
        let obj = {};
        obj.quiz_unit_id = this.state.quiz_data.quiz_unit_id;
        obj.course_unit_id = this.props.Details.course_unit_id;
        obj.coursemaster_id = this.props.Details.coursemaster_id;
        obj.question_id = this.props.unitDetails.main_question_id;
        obj.start_time = this.state.start;
        obj.no_of_attempted = 1;
        obj.total_point = 5;
        obj.answer_id = this.props.unitDetails.question_options[0].option_id;
        obj.obtained_score = this.state.quiz_data.marks_for_correct_answer;
        obj.accuracy =
          (100 * this.state.quiz_data.marks_for_correct_answer) /
          this.state.quiz_data.marks_for_correct_answer;
        obj.obtained_point = 5;
        obj.time_spent_duration =
          parseInt(this.state.date) - parseInt(this.state.start);
        obj.total_score = this.state.quiz_data.marks_for_correct_answer;
        obj.end_time = this.state.date;
        if (localStorage.getItem("quiz")) {
          var cart = [];
          cart = JSON.parse(localStorage["quiz"]);
          cart.push(obj);
          console.log(cart);
          localStorage.setItem("quiz", JSON.stringify(cart));
        } else {
          var arra = [];
          arra.push(obj);
          console.log(arra);
          localStorage.setItem("quiz", JSON.stringify(arra));
        }
      } else {
        cogoToast.error("Wrong", { position: "top-center" });
        this.setState({ rightAns: "none", wrongAns: "block" });
        answer = [];
        this.props.playIncorrectAudio();
        var a = {};
        a.answer = "Wrong";
        a.text = this.props.unitDetails.incorrect_feedback;
        a.video = this.props.unitDetails.incorrect_feedback_video;
        this.setState({ open: true, explain_data: a });

        let obj = {};
        obj.quiz_unit_id = this.state.quiz_data.quiz_unit_id;
        obj.course_unit_id = this.props.Details.course_unit_id;
        obj.coursemaster_id = this.props.Details.coursemaster_id;
        obj.question_id = this.props.unitDetails.main_question_id;
        obj.start_time = this.state.start;
        obj.no_of_attempted = 1;
        obj.total_point = 5;
        obj.answer_id = this.props.unitDetails.question_options[0].option_id;
        obj.obtained_score = this.state.quiz_data.marks_for_correct_answer;
        obj.accuracy =
          (100 * this.state.quiz_data.marks_for_correct_answer) /
          this.state.quiz_data.marks_for_correct_answer;
        obj.obtained_point = 0;
        obj.time_spent_duration =
          parseInt(this.state.date) - parseInt(this.state.start);
        obj.total_score = this.state.quiz_data.marks_for_correct_answer;
        obj.end_time = this.state.date;
        if (localStorage.getItem("quiz")) {
          var scores = JSON.parse(localStorage.getItem("quiz"));
          var exist = false;
          for (let i = 0; i < scores.length; i++) {
            if (obj.question_id == scores[i].question_id) {
              scores[i] = obj;
              exist = true;
              localStorage.setItem("quiz", JSON.stringify(scores));
            }
          }
          if (!exist) {
            var cart = [];
            cart = JSON.parse(localStorage["quiz"]);
            cart.push(obj);
            localStorage.setItem("quiz", JSON.stringify(cart));
          }
        } else {
          var arra = [];
          arra.push(obj);
          console.log(arra);
          localStorage.setItem("quiz", JSON.stringify(arra));
        }
      }
      // document.querySelector('.next-btn').classList.remove('disable')
      setTimeout(() => {
        const allAnswerLetter = document.querySelectorAll(".answer-letter");
        for (let i = 0; i < allAnswerLetter.length; i++) {
          allAnswerLetter[i].style.pointerEvents = "none";
        }
      }, 100);
    }
  };

  printAnswer = () => {
    return this.state.answerArr.map(letter => {
      return (
        <div
          onClick={this.removeFromAnswer}
          className="answer-letter shadow-sm"
          style={{
            padding: `${this.state.optionsArr.length > 6 ? "7px 10px" : ""}`
          }}
        >
          {letter}
        </div>
      );
    });
  };
  removeFromAnswer = e => {
    e.target.remove();
    let value = e.target.innerHTML;
    const optionItems = document.querySelectorAll(".split-letter");
    for (let i = 0; i < optionItems.length; i++) {
      if (value === optionItems[i].innerHTML) {
        optionItems[i].classList.remove("blank-item");
        optionItems[i].style.pointerEvents = "unset";
      }
    }
    var pos = answer.indexOf(value);
    answer.splice(pos, 1);
  };
  nextque = () => {
    this.props.parentMethod();
  };
  onOpenModal_Explain = () => {
    this.setState({ open: true });
  };
  onCloseModal_Explain = () => {
    this.setState({ open: false });
    const allRadioButtons = document.querySelectorAll(".radio-button");
    for (let i = 0; i < allRadioButtons.length; i++) {
      allRadioButtons[i].classList.add("disabled");
    }
    setTimeout(() => {
      this.nextque();
      if (document.querySelector(".selected-radio")) {
        document
          .querySelector(".selected-radio")
          .classList.remove("selected-radio");
      }
      for (let i = 0; i < allRadioButtons.length; i++) {
        allRadioButtons[i].classList.remove("disabled");
      }
    }, 100);
  };
  render() {
    return (
      <div className="quiz-model four-pic-one-word text-center">
        <div className="rounded">
          <div className="heading-block">
            <p
              className="text-4 text-black m-0 question-quiz"
              id="question_title"
              dangerouslySetInnerHTML={{
                __html: this.props.unitDetails.question_title
              }}
            ></p>
          </div>
          <div className="modal-body">
            <div className="row inner-game-container mx-auto">
              <div className="col-md-6">
                <figure
                  className="m-auto text-center"
                  style={{ opacity: this.state.opacity }}
                >
                  <div className="row mb-4 justify-content-around">
                    {this.props.unitDetails.question_media !== null &&
                    this.props.unitDetails.question_media !== undefined &&
                    this.props.unitDetails.question_media !== [] &&
                    this.props.unitDetails.question_media.length > 0
                      ? this.props.unitDetails.question_media.map(media => (
                          <div
                            className={`${
                              this.props.unitDetails.question_media.length > 1
                                ? "col-md-6 p-1"
                                : "col p-1"
                            }`}
                          >
                            <img
                              alt=""
                              className="img-category quiz-image"
                              src={media.media_url ? media.media_url : ""}
                            />
                          </div>
                        ))
                      : ""}
                    {/* {this.props.unitDetails.question_media !== null &&
                    this.props.unitDetails.question_media !== undefined &&
                    this.props.unitDetails.question_media !== [] &&
                    this.props.unitDetails.question_media.length > 0 ? (
                      <div className="col p-1">
                        <img
                          alt=""
                          className="img-category quiz-image"
                          src={
                            this.props.unitDetails.question_media[0].media_url
                              ? this.props.unitDetails.question_media[0]
                                  .media_url
                              : ""
                          }
                        />
                      </div>
                    ) : (
                      ""
                    )} */}
                  </div>
                </figure>
              </div>
              <div className="col-md-6 d-flex justify-content-center align-items-center ">
                <div>
                  <div className="split-answer-letters-box d-block d-flex my-3 mx-auto border p-2">
                    {this.state.answerArr === undefined
                      ? null
                      : this.printAnswer()}
                  </div>
                  <div className="split-letters-box d-block d-flex mx-auto mb-3 border p-2">
                    {this.state.optionsArr !== undefined
                      ? this.printOption()
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row d-flex justify-content-center my-3 next-btn">
          <div className="text-center text-danger text-3">
            <span> {this.state.error} </span>
          </div>
          {/* <button
            type="button"
            onClick={this.nextque}
            className="btn btn-dark nxt-btn shadow-sm"
          >
            Next
          </button> */}
        </div>
        {/* <Explanation
          explain_data={this.state.explain_data}
          open={this.state.open}
          close={this.onCloseModal_Explain}
        /> */}
      </div>
    );
  }
}
export default QuizFourPicOneWord;
